import questionBank from '@/data/question-bank.json'
import personas from '@/data/persona-results.json'

export const QUESTIONNAIRE_STORAGE_KEY = 'sexual-persona:questionnaire:v1'
export const QUESTIONNAIRE_STORAGE_VERSION = 1

export const ANSWER_OPTIONS = [
  { key: 'stronglyAgree', label: 'Strongly Agree' },
  { key: 'agree', label: 'Agree' },
  { key: 'neutral', label: 'Neutral' },
  { key: 'disagree', label: 'Disagree' },
  { key: 'stronglyDisagree', label: 'Strongly Disagree' }
]

export const QUESTION_BANK = questionBank.questions
export const QUESTION_DIMENSIONS = questionBank.dimensions

export function getQuestionProgress(questionNumber) {
  const current = Math.min(Math.max(Number(questionNumber) || 1, 1), QUESTION_BANK.length)

  if (current <= 20) {
    return (current / 20) * 50
  }

  if (current <= 40) {
    return 50 + ((current - 20) / 20) * 25
  }

  return 75 + ((current - 40) / 40) * 25
}

export function calculateQuestionnaireScores(answers = {}) {
  const scores = QUESTION_DIMENSIONS.reduce((result, dimension) => {
    result[dimension.key] = { left: 0, right: 0 }
    return result
  }, {})

  QUESTION_BANK.forEach(question => {
    const answer = answers[String(question.id)]
    const points = question.scores[answer]

    if (!points) return

    scores[question.dimension].left += points.left
    scores[question.dimension].right += points.right
  })

  return scores
}

export function getQuestionnaireSnapshot(answers = {}) {
  const scores = calculateQuestionnaireScores(answers)
  const answeredCount = QUESTION_BANK.reduce((count, question) => {
    return question.scores[answers[String(question.id)]] ? count + 1 : count
  }, 0)
  const isComplete = answeredCount === QUESTION_BANK.length

  if (!isComplete) {
    return {
      answeredCount,
      totalQuestions: QUESTION_BANK.length,
      scores,
      result: null
    }
  }

  const resultDimensions = QUESTION_DIMENSIONS.map(dimension => {
    const dimensionScore = scores[dimension.key]
    const leftWins = dimensionScore.left >= dimensionScore.right

    return {
      key: dimension.key,
      label: dimension.label,
      winner: leftWins ? dimension.left : dimension.right,
      left: {
        name: dimension.left,
        score: dimensionScore.left,
        percentage: Math.round((dimensionScore.left / 64) * 100)
      },
      right: {
        name: dimension.right,
        score: dimensionScore.right,
        percentage: Math.round((dimensionScore.right / 64) * 100)
      }
    }
  })
  const personaId = `P${resultDimensions.map(dimension => {
    return dimension.left.score >= dimension.right.score ? '1' : '0'
  }).join('')}`
  const persona = personas.find(item => item.id === personaId)

  return {
    answeredCount,
    totalQuestions: QUESTION_BANK.length,
    scores,
    result: {
      personaId,
      personaName: persona ? persona.name : '',
      dimensions: resultDimensions
    }
  }
}
